import React from 'react';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import { formatCurrency } from '../../../../helpers/format';
import { useTranslation } from 'react-i18next';

const TournamentReminderDialog = ({data, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const BTN_NAMES = {
    confirm: t('startTournament'),
    cancel: t('close'),
  };

  const { currency: guaranteedCurrency, value: guaranteedValue } = data.guaranteed;
  const { currency, buyin, fee } = data.buyIn;

  data = {
    startMessage: `Hi, You have registered for below tournament which has 
    just started. click the button below to start playing. 
    good luck and enjay!`,
    guaranteed: `${formatCurrency(guaranteedValue, 'eng', guaranteedCurrency)} ${t('guaranteed')} - Rebuy`, /* will translate 'Rebuy'  */
    limit: `${data.numberOfSpins} Spin Limit Scheduled Tournament`,
    currency: currency,
    totalCharge: formatCurrency(buyin, 'eng', currency),
    fee: formatCurrency(fee, 'eng', currency),
  };

  return (
    <>
      {data && 
        <div className="tournaments__popup tournament__dialog__reminder">
        <div className="tournaments__popup__overlay tournaments_reminder__overlay" onClick={onClose} />

        <PopUpDialogTemplate
          title={'Tournament Reminder'}
          iconName={'clock'}
          onConfirm={onConfirm}
          onClose={onClose}
          btnNames={BTN_NAMES}
          >
          <div className="tournaments__dialog-start-text">{data.startMessage}</div>
          <div className="tournament__dialog-gold-text">{data.guaranteed}</div>
          <span>
            {data.limit}
          </span>
          <span>
            {`Tournament Currency: ${data.currency}`}
          </span>
          <div className="tournament__dialog-currency">
            <span>{`Buy in:`} <p>{data.totalCharge}</p></span>
            <span>{`Entry Fee:`} <p>{data.fee}</p></span>
            <span>{`Pot cost:`} <p>{data.fee}</p></span>
          </div>
        </PopUpDialogTemplate>
      </div>
      }
    </>
  )
}

export default TournamentReminderDialog;